function FullscreenGallery(source, container) {
  this.init = function () {
    this.galleryContainer = document.querySelector(container || '#fullscreen-gallery');
    this.sourceContainer = document.querySelector(source || '.horizon-swiper');
    this.images = this.getImagesList();

    this.currImg = this.galleryContainer.querySelector('.slider__cur-img');
    this.itemNumberHolder = this.galleryContainer.querySelector('.slider__table-td-item-number');
    this.titleHolder = this.galleryContainer.querySelector('.slider__table-td-item-title');

    this.galleryContainer.querySelector('.slider__btn_prev')
      .addEventListener('click', this.prev.bind(this));
    this.galleryContainer.querySelector('.slider__btn_next')
      .addEventListener('click', this.next.bind(this));
    this.galleryContainer.querySelector('.slider__btn_close')
      .addEventListener('click', this.close.bind(this));
  }

  this.close = function () {
    this.galleryContainer.style.display = 'none';
  }

  this.open = function (img) {
    this.galleryContainer.style.display = 'block';
    this.setImg(img);
    this.setTitle();
    this.setItemNumber();
  }

  this.getImagesList = function () {
    return Array.from(this.sourceContainer.querySelectorAll('.horizon-item img'))
      .map(item => ({src: item.dataset.src, title: item.dataset.title}))
      .filter((value, index, self) => self.indexOf(value) === index);
  }

  this.getIndex = function () {
    return this.images.map(item => item.src).indexOf(this.currImg.src)
  }

  this.setItemNumber = function () {
    const totalNumber = this.images.length;
    const currIndex = this.getIndex();
    this.itemNumberHolder.innerHTML = `${currIndex + 1}/${totalNumber}`;
  }

  this.setImg = function (img) {
    this.currImg.src = img.src;
  }

  this.setTitle = function () {
    const index = this.getIndex();
    this.titleHolder.innerHTML = this.images[index].title;
  }

  this.next = function () {
    const index = this.getIndex();
    let id = this.images[index + 1] ? index + 1 : 0;
    this.setImg(this.images[id]);
    this.setTitle();
    this.setItemNumber();
  }

  this.prev = function () {
    const index = this.getIndex();
    let id = this.images[index - 1] ? index - 1 : this.images.length - 1;
    this.setImg(this.images[id]);
    this.setTitle();
    this.setItemNumber();
  }

  this.init();
}
